module.exports = __webpack_public_path__ + "assets/info-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/info-icon.png
// module id = 1221
// module chunks = 7